var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export const Links = (_a) => {
    var { children, to, target = '_self', outside = false, Link } = _a, otherProps = __rest(_a, ["children", "to", "target", "outside", "Link"]);
    return (React.createElement(React.Fragment, null, outside || !Link ? (React.createElement("a", Object.assign({ href: to, target: target, rel: 'noreferrer noopener' }, otherProps), children)) : (React.createElement(Link, { href: to, as: to },
        React.createElement("a", Object.assign({}, otherProps), children)))));
};
//# sourceMappingURL=links.js.map